<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('blogDetails.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class=" mx-3 almarai-bold">
              <router-link to="/blog">{{$t('blogDetails.breadcrumb_2')}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">
              {{$t('blogDetails.breadcrumb_3')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="row" v-if="isLoading">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div v-else class="row">
          <div class="col">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <div class="row">
              <div class="col py-3">
                <div class="card blog-card">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="col-12 col-sm-6 text-center">
                        <img :src="MEDIA_URL+row.image" class="w-100 br-radius" alt="">
                      </div>
                    </div>
                    <div>
                      <h5 class="pt-3">{{row.title}}</h5>
                      <p class="preLine">{{row.subject}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'blogDetails',
  data(){
    return {
      hasError: false,
      errorNumber: 0,
      message: "",
      isLoading: true,
      blogID: this.$route.params.key,
      row: {},
      userLang: 'ar',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    getData(){
      this.hasError = false;
      this.$http.get("/api/forums/retrieve/"+this.blogID).then(res => {
        // console.log(res);
        this.row = res.data.row;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = false;
      });
    },
  },
  created(){
    this.getData();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>